import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Post} from "../../../../shared/interface/post";
import {PageManager} from "../../../../shared/interface/page-manager";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {Dictionary} from "../../../../shared/interface/dictionary";
import {Regional} from "../../../../shared/interface/regional";
import {InsuranceCompany} from "../../../../shared/interface/insurance-company";
import {PermissionsTag} from "../../../../shared/interface/permissions-tag";
import {Profile} from "../../../../shared/interface/profile";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {AuthService} from "../../../../shared/services/auth.service";
import {PostService} from "../../../../shared/services/post.service";
import {DictService} from "../../../../shared/services/dict.service";
import {RegionalService} from "../../../../shared/services/regional.service";
import {PermissionTagsService} from "../../../../shared/services/permission-tags.service";
import {InsuranceCompanyService} from "../../../../shared/services/insurance-company.service";
import {first, takeUntil} from "rxjs/operators";
import {Attachments} from "../../../../shared/interface/attachments";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {TagService} from "../../../../shared/services/tag.service";
import {Tag} from "../../../../shared/interface/tag";


@Component({
  selector: 'app-page-details-view',
  templateUrl: './page-details-view.component.html',
  styleUrls: ['./page-details-view.component.scss']
})
export class PageDetailsViewComponent implements OnInit, OnDestroy {

  @Input() page: Observable<PageManager>;
  @Output() modifyClicked = new EventEmitter<any>();

  pageObject?: PageManager;
  userPermissions: ReplaySubject<UserPermissions>;

  permissionTagPartner: Dictionary[] = [];
  permissionContractType: Dictionary[] = [];
  permissionIddTrainingStatus: Dictionary[] = [];
  permissionRegistration: InsuranceCompany[] = [];
  permissionTag: PermissionsTag[] = [];
  profile: Profile;
  initialFilters: any;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private postService: PostService,
    private dictService: DictService,
    private insuranceCompanyService: InsuranceCompanyService
  ) {
    this.userPermissions = auth.getUserPermissions();

  }

  ngOnInit(): void {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.page
      .pipe(takeUntil(this.destroyed$))
      .subscribe((page: PageManager) => {
        this.pageObject = page;
        this.pageObject.pageDetails.sort(  (a, b) => a.pageDetailIndex - b.pageDetailIndex );
        this.loadPermision(page);
      });
  }

  loadPermision(page: PageManager): void {
    this.permissionTagPartner = [];
    page.permissionTagPartner.forEach((dictId: number) => {
      this.dictService.getDict(dictId)
        .subscribe((dict: Dictionary) => {
          this.permissionTagPartner.push(dict);
        });
    });
    this.permissionRegistration = [];
    this.insuranceCompanyService.loadList(0, 1000, {});
    this.insuranceCompanyService.getInsuranceCompaniesPageSubject()
      .pipe(first())
      .subscribe((result: CountedAndPaginated<InsuranceCompany>) => {
        result.items.forEach((insuranceCompany: InsuranceCompany) => {
          if ( page.permissionRegistrationList.includes(insuranceCompany.id)) {
            this.permissionRegistration.push(insuranceCompany);
          }
        });

      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }




  downloadAttachment(attachment: Attachments): void {
    this.postService.downloadAttachment(attachment.uuid);
  }
  downloadAttachmentFile(fileLocation: string, fileName: string): void {
    this.postService.downloadAttachmentFile(fileLocation, fileName);
  }


}
